export default __webpack_public_path__ + "static/media/1865.6336ea2f.png";